var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainContentTabs',{attrs:{"tabs":[
        { tab : 'parcelas', nombre: 'Por parcela' },
        { tab : 'zona', nombre: 'Por zona' }
    ],"atras":false,"initialTab":"parcelas"}},[_c('template',{slot:"parcelas"},[_c('PreciosParcelas')],1),_c('template',{slot:"zona"},[_c('PreciosParcelasPorZonasComponent')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }